import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import tagsApi from '@/features/dashboard/tags/api/tagsApi.ts';
import { tagsApiQueryKeys } from '@/features/dashboard/tags/api/tagsApi.queryKeys.ts';
import { TagWebDto } from '@/features/dashboard/tags/types/TagWebDto.ts';

/**
 * Creates a tag. The endpoint is create-or-get, so calling it with an
 * existing name returns that tag instead of creating a duplicate.
 */
export default function useCreateTag() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: TagWebDto) => tagsApi.create(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tagsApiQueryKeys.all() });
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description: error.message || 'Nie udało się utworzyć tagu.',
      });
    },
  });
}
